import type { ReactElement, ReactNode } from "react";
import styles from "./SubsectionHeader.module.css";

export interface SubsectionHeaderProps {
  label: string;
  trailing?: ReactNode;
  /** First header in a body — drops the top inset so it sits flush. */
  first?: boolean;
}

/** In-panel group label — Mono/Eyebrow voice, the same as legend titles. */
export function SubsectionHeader({
  label,
  trailing,
  first = false
}: SubsectionHeaderProps): ReactElement {
  return (
    <div
      className={`${styles.header}${first ? ` ${styles.headerFirst}` : ""}`}
      data-inspector-subsection-header
    >
      <span className={styles.label}>{label}</span>
      {trailing != null ? (
        <span className={styles.trailing}>{trailing}</span>
      ) : null}
    </div>
  );
}
